module.exports = __webpack_public_path__ + "static/media/meme_14.7c1e29b8.jpg";